module.exports = __webpack_public_path__ + "img/HZ-P6008.4905ef08.jpg";